<template>
    <div class="helpBox privacy" id="agreementBox">
        <h1><img src="//img.fenfenriji.com//ED/56/AF/Image/6BE8C4BF-B534-52C9-019A-5AB1C602A62C.png" alt="" style="display: block;width: 300px;margin: 0 auto;"></h1>
        <h2><i class="fill fill3"></i>引言</h2>
        <p>欢迎使用本软件提供的各种服务（以下简称“服务”），您同意认可并有义务遵守本《用户协议》（以下简称“协议”）。在本协议中，“用户”是指下载安装运行使用本软件的个人或者单位，申请注册的会员。用户同意此在线协议之效力如同用户亲自签字、盖章的书面条款一样，对用户具有法律约束力。开发者，这里表示上海盘隆科技有限公司，是指对粉粉日记，粉粉社区，可萌记账，粉粉手帐等粉粉系列软件（以下简称“本软件”）拥有著作版权和商标的团体或者单位。用户进一步同意，用户进入软件注册程序即意味着用户同意了本协议的所有内容且只有用户完全同意所有协议并完成注册程序，才能成为软件的正式用户。本协议自用户注册成功之日起在用户与开发者之间产生法律效力。若您不同意本协议，请不要访问网页或使用服务。开发者有权随时更改“协议”，我方建议您事前访问网页以了解是否有所变更。</p>
        <h2><i class="fill fill3"></i>服务简介</h2>
        <p>开发者向其用户提供包括各个手机平台下的应用软件，游戏，铃声，彩信，设计资源，社区服务，开发者服务，广告等在内的移动互联网技术服务和网络服务。</p>
        <br>
        <h2><i class="fill fill3"></i>用户身份保证</h2>
        <p>（1） 用户承诺并保证自己是具有完全民事行为能力和完全民事权利能力的自然人、法人、实体和组织。用户在此保证所填写的用户信息是真实、准确、完整、及时的，并且没有任何引人误解或者虚假的陈述，且保证开发者可以通过用户所填写的联系方式与用户取得联系。</p>
        <p>（2）用户应根据开发者对于相关服务的要求及时提供相应的身份证明等资料，否则开发者有权拒绝向该用户提供相关服务。</p>
        <p>（3）用户承诺将及时更新其用户信息以维持该等信息的有效性，并且不侵犯他人权益。<span id="transmark"></span></p>
        <p>（4）如果用户提供的资料或信息包含有不正确、不真实的信息，或者对其他用户的正常行为产生干扰，开发者保留取消用户会员资格并随时结束为该用户提供服务的权利。</p>
        <p>（5）未经许可，用户的名称、头像、签名等信息，不得侵犯真实注册用户的权益；不得含有未经开发者许可的商业或者广告信息。</p>
        <p>（6）以代理人身份代理其他自然人或者单位进行注册的用户必须向开发者提供代理人和被代理人的详细资料和信息及授权书面文件，未向开发者提供上述资料信息及文件的，开发者将视注册者为会员。</p>
        <p>（7）用户在本软件中或通过本软件相关服务所传送的任何内容并不反映开发者的观点或政策，开发者对此不承担任何责任。</p>
        <br>
        <h2><i class="fill fill3"></i>邮件短信通知</h2>
        <p>用户充分理解开发者将通过手机短信、电子邮件的方式与注册会员保持联络及沟通，用户在此同意开发者通过手机短信、电子邮件方式向其发送包括会员信息、服务信息在内的相关商业及非商业联络信息。</p>
        <br>
        <h2><i class="fill fill3"></i>用户的权利和义务</h2>
        <p>（1） 用户有权利拥有自己在软件的用户名和密码并有权利使用自己的用户名和密码随时登录开发者的各种服务产品。</p>
        <p>（2） 用户有权利享受开发者提供的移动互联网技术和信息服务，并有权利在接受开发者提供的服务时获得开发者的技术支持、咨询等服务，服务内容详见开发者相关产品介绍。</p>
        <p>（3） 用户保证不会利用技术或其他手段破坏及扰乱开发者服务产品以及开发者其他客户的网站，不得对软件进行反向工程、反向汇编、反向编译、数据包截获等。</p>
        <p>（4） 用户应尊重开发者及其他第三方的知识产权和其他合法权利，并保证在发生上述事件时尽力保护开发者及其股东、雇员、合作伙伴等免于因该等事件受到影响或损失；开发者保留用户侵犯开发者知识产权时终止向该用户提供服务并不退还任何款项的权利。</p>
        <p>（5） 对由于用户向开发者提供的联络方式有误以及用户用于接受开发者邮件的电子邮箱安全性、稳定性不佳而导致的一切后果，用户应自行承担责任，包括但不限于因用户未能及时收到开发者的相关通知而导致的后果和损失。</p>
        <p>（6） 用户保证其使用开发者服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用开发者提供的服务进行存储、发布、传播如下信息和内容：违反国家法律法规政策的任何内容（信息）；违反国家规定的政治宣传和/或新闻信息；涉及国家秘密和/或安全的信息；封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息；博彩有奖、赌博游戏；违反国家民族和宗教政策的信息；防碍互联网运行安全的信息；侵害他人合法权益的信息和/或其他有损于社会秩序、社会治安、公共道德的信息或内容。用户同时承诺不得为他人发布上述不符合国家规定和/或本服务条款约定的信息内容提供任何便利，包括但不限于设置URL、BANNER链接等。用户承诺其创作行为，评论均属个人行为，不代表开发者立场。用户承认开发者有权在用户违反上述时有权终止向用户提供服务并不予退还任何款项，因用户上述行为给开发者造成损失的，用户应予赔偿。</p>
        <p>（7） 用户不应将其帐号、密码转让或出借予他人使用。如因用户提供虚假资料或被他人获悉自己的注册资料而其帐号遭他人非法使用，应立即通知本软件。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，本软件不承担任何责任。 </p>
        <p>（8） 帐号使用权仅属于初始申请注册人，禁止赠予、借用、租用、转让或售卖。如发现使用者并非帐号初始注册人，本软件有权在未经通知的情况下回收该帐号而无需向该帐号使用人承担法律责任，由此带来的包括并不限于用户通讯中断、用户资料清空等损失由用户自行承担。禁止用户私下有偿或无偿转让帐号，以免因帐号问题产生纠纷，用户应当自行承担因违反此要求而遭致的任何损失，同时本软件保留追究上述行为人法律责任的权利。</p>
        <br>
        <h2><i class="fill fill3"></i>知识产权（商标和版权）</h2>
        <p>开发者的logo和名称，开发者的设计上均有开发者的商标或商业外观，未经开发者书面允许不可用于商业用途。所有出现在网页上而不属于开发者的商标其所有权均归各自所有人所有，其所有人不一定与开发者有关联。</p>
        <p>开发者的原创性内容，如文本、图案、logo、软件及网页上的所有编排所有权都归开发者和其许可方所有，并受中国、美国和国际版权法保护。未经开发者书面许可不许复制任何开发者的原创内容，“协议”中列出的内容除外。</p>
        <br>
        <h2><i class="fill fill3"></i>用户原创内容（UGC）知识产权</h2>
        <p>（1）用户承诺对其上传或者发表于本软件的所有信息（即属于《中华人民共和国著作权法》规定的作品，包括但不限于文字、图片、音乐、电影、表演、录音录像制品和电脑程序等）均享有完整的知识产权，或者已经得到相关权利人的合法授权。</p>
        <p>（2）当第三方认为用户上传或者发表于的信息侵犯其权利，并根据《信息网络传播权保护条例》或者相关法律规定向本软件官方发送权利通知书时，用户同意本软件可以自行判断决定删除涉嫌侵权的用户上传或者发表于本软件的信息，除非收到符合相关法律规定且可以证明本软件不承担任何法律责任的书面说明，本软件将不会自动恢复上述删除的信息，由此给涉嫌侵权的用户带来的任何损失，本软件不承担任何法律责任。</p>
        <p>
            （3）如用户在使本软件登载的信息或内容侵犯了您的权利，您可以发送通知书至【xxtstudio@163.com】，要求删除该侵权信息或内容。通知书须由权利人或经其合法授权的人亲笔签名，若为单位则还须加盖单位公章。 通知书应当包含下列内容：<br>
            1) 您的姓名（名称）、联系方式、地址、身份证复印件（自然人）、单位登记证明复印件（单位）；<br>
            2) 要求删除内容或信息的准确名称和网络地址，以便能够发现并确认侵权内容； <br>
            3) 认为构成侵权的初步证明材料，包括但不限于对被侵犯对象的权属证明等。 您应对通知书的真实性负责。若通知书的内容不真实，您将承担由此造成的全部法律责任。 <br>
        </p>
        <p>
            （4）本软件收到您发出的以上通知后会及时对侵犯事实进行核查，核查确认您的侵犯通知书事实无误的情况下，本软件将：<br>
            1) 立即删除涉嫌侵权的内容或信息，并同时将通知书转送作品或内容的提供者； <br>
            2) 除履行通知程序外，对使用同一账号多次上传同一侵权作品的用户，本软件有权不事先通知随时终止该帐号的使用。 <br>
            3) 如用户在使用本软件时违反上述任何规定，本软件有权要求用户改正或直接采取一切必要的措施（包括但不限于删除用户张贴的内容、暂停或终止用户使用网络服务的权利）以减轻用户不当行为而造成的影响。由此给该用户带来的任何损失，本软件不承担任何法律责任。<br>
        </p>
        <br>
        <h2><i class="fill fill3"></i>互联网用户不得制作、复制、发布、传播含有下列内容的信息：</h2>
        <p>（1）反对宪法所确定的基本原则的；</p>
        <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p>（3）损害国家荣誉和利益的；</p>
        <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
        <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
        <p>（9）含有法律、行政法规禁止的其他内容的。</p>
        <br>
        <h2><i class="fill fill3"></i>免责声明 </h2>
        <p>（1） 由于您将用户密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄漏，或其他非因本软件原因导致的个人信息的泄漏，本软件不承担任何法律责任； </p>
        <p>（2） 任何第三方根据本软件规则列明的情况使用您的个人信息，由此所产生的纠纷，本软件不承担任何法律责任；</p>
        <p>（3） 我们鼓励用户充分利用本软件自由地发布和共享自己的信息。您可以自由发布/上传/共享图片等内容，但您应拥有这些内容的使用权。同时，用户不应在自己的个人主页或社区中发布其他受版权保护的内容。</p>
        <p>（4） 用户在本软件发表的内容（包含但不限于本软件目前各产品功能里的内容）仅表明其个人的立场和观点，并不代表本软件的立场或观点。</p>
        <p>（5） 用户在本软件发布侵犯他人知识产权或其他合法权益的内容，本软件有权予以删除，并保留移交司法机关处理的权利。</p>
        <p>（6） 用户对于其创作并在本软件上发布的合法内容依法享有著作权及其相关权利。</p>
        <p>（7） 互联网是一个开放平台，用户将图片等资料上传到互联网上，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，用户必须充分意识此类风险的存在。用户明确同意其使用本软件服务所存在的风险将完全由其自己承担；因其使用本软件服务而产生的一切后果也由其自己承担，本软件对用户不承担任何法律责任。</p>
        <p>（8） 对免责声明的解释、修改及更新权均属于本软件所有。</p>
        <br>
        <h2><i class="fill fill3"></i>无保证和责任限制</h2>
        <p>开发者的网页和服务没有任何明确的、隐晦的或法定的保证或条件。开发者明确表示拒绝承担任何隐含的适用消费保证、特定用途之适用性担保、无侵权担保、信息准确度担保、集成担保、互通性担保或平静受益权担保。</p>
        <p>你了解并同意使用本网页和服务，风险自担，你独自承担任何使用移动互联网数据和任何损害的费用。开发者对任何直接的、间接的、特殊的、偶然的、重要的或惩罚性的损害或费用概不负责；损害包括但不限于与使用相关的损害、滥用、无法使用、网页或服务中断、暂停或终止。您对该网页或服务不满意的仅有权利是终止使用网页和服务。</p>
        <br>
        <h2><i class="fill fill3"></i>不可抗力</h2>
        <p>（1） 因不可抗力或者其他意外事件，使得本协议履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。</p>
        <p>（2） 不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。</p>
        <p>（3） 用户同意鉴于互联网的特殊性，黑客攻击、互联网连通中断或者系统故障等属于不可抗力，由此给用户或者第三方造成的损失不应由开发者承担。</p>
        <h3>本条款的最终解释权归上海盘隆科技有限公司所有。</h3>
        <div style="height: 30px;"></div>
    </div>
</template>
<script>
    export default {

    }
</script>



// WEBPACK FOOTER //
// src/components/agreement/agreement3.vue